// extracted by mini-css-extract-plugin
module.exports = {"block":"MasseyRatings_block__CcB0y"};